// Help text for: Chatbot.
// Keys are referenced as "chatbot.<field>" by <FieldHelp id=... />. Entry shape:
//   title  - field name as shown on screen
//   use    - what the field is for / how to read it
//   source - measured | calculated | backend | default | setting | input
//   how    - where the value comes from: formula, default value, or who sets it
const help = {
  // ---------- Chatbot page ----------
  username: {
    title: "Username",
    use: "Your EnViz username. The assistant uses the same login as the dashboard.",
    source: "input",
    how: "Checked when you press Sign in. Logins whose dashboard access has been switched off are turned away. If you are already signed in to the dashboard you are not asked again.",
  },
  password: {
    title: "Password",
    use: "Your EnViz password.",
    source: "input",
    how: "Sent only to sign you in. It is never kept in your browser.",
  },
  enix: {
    title: "Enix",
    use: "Enix is the EnViz AI assistant. Ask it about your energy use, machines, peaks, costs or tariffs in everyday words.",
    source: "backend",
    how: "It works out what you are asking about — the subject, the machines and the dates — pulls the matching readings from your plant, then writes the answer with an AI language model. Each question and answer is kept in your chat history, named after your first question, up to 60 characters.",
  },

  // ---------- AI Analyzer (chart pop-up) ----------
  aiAnalyzer: {
    title: "AI Analyzer",
    use: "Explains the chart in front of you in plain words: which way it is going, what may be behind it, and what to do next.",
    source: "backend",
    how: "The chart's plotted numbers, its title, unit, dates and line names are sent off; the figures are worked out from them and an AI model writes the text. If the AI service is down, a fixed-rules summary built from the same figures is shown instead.",
  },
  statMin: {
    title: "Minimum",
    use: "The lowest number plotted on the chart.",
    source: "calculated",
    how: "The lowest point across every line on the chart, in the chart's unit, to 2 decimal places.",
  },
  statMax: {
    title: "Maximum",
    use: "The highest number plotted on the chart.",
    source: "calculated",
    how: "The highest point across every line on the chart, in the chart's unit, to 2 decimal places.",
  },
  statAvg: {
    title: "Average",
    use: "The usual level of the chart over the chosen window.",
    source: "calculated",
    how: "A plain average of every plotted point, all lines pooled together rather than one figure per machine, in the chart's unit, to 2 decimal places.",
  },
  trend: {
    title: "Overall Trend",
    use: "One word for which way the chart went over the window.",
    source: "calculated",
    how: "The first plotted number is compared with the last. A change of less than 3% of the starting number reads Stable. Otherwise it reads Fluctuating when the spread is more than 25% of the average, and Increasing or Decreasing if not.",
  },
  conciseSummary: {
    title: "Concise Summary",
    use: "The main thing to take away from the chart, in one sentence.",
    source: "backend",
    how: "Written by the AI model from the chart's figures: lowest, highest, average, direction, when the peak happened and the numbers for each machine. The wording changes from one run to the next.",
  },
  trendAnalysis: {
    title: "Overall Trend Analysis",
    use: "A short account of how the numbers moved over the window.",
    source: "backend",
    how: "Written by the AI model from the start and end numbers, the spread, and the times of the peak and the low point.",
  },
  possibleCauses: {
    title: "Possible Causes & Insights",
    use: "Likely reasons behind the pattern on the chart, to point your digging in the right direction.",
    source: "backend",
    how: "2–3 ideas written by the AI model from the chart's figures and any odd points that were flagged. They are suggestions, not proven findings.",
  },
  recommendedActions: {
    title: "Recommended Actions & Preventive Measures",
    use: "Practical steps you could take on what the chart shows.",
    source: "backend",
    how: "2–3 steps written by the AI model from the same chart figures. Weigh them against what you know about your own site before acting.",
  },
};

export default help;
